import { render } from "./info-insurance.vue?vue&type=template&id=19a82144&ts=true"
import script from "./info-insurance.vue?vue&type=script&lang=ts"
export * from "./info-insurance.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__